/**
 * Countdown Timer for Carousal
 * Counts down to the next Sunday at midnight
 */
class CountdownTimer {
  constructor(elementId) {
    this.elementId = elementId;
    this.element = document.getElementById(elementId);
    
    if (!this.element) return;
    
    this.daysElement = this.element.querySelector(".countdown-days");
    this.hoursElement = this.element.querySelector(".countdown-hours");
    this.minutesElement = this.element.querySelector(".countdown-minutes");
    this.secondsElement = this.element.querySelector(".countdown-seconds");
    
    this.countDownDate = this.getNextSundayMidnight();
    this.startCountdown();
  }
  
  getNextSundayMidnight() {
    const now = new Date();
    // Se oggi è domenica e non è ancora mezzanotte, usa la mezzanotte di oggi
    if (now.getDay() === 0 && now.getHours() < 24) {
      const targetDate = new Date(now);
      targetDate.setHours(23, 59, 59, 999);
      return targetDate.getTime();
    }
    
    // Altrimenti, calcola la prossima domenica
    let daysUntilSunday = 7 - now.getDay();
    if (daysUntilSunday === 0) {
      daysUntilSunday = 7;
    }
    
    const targetDate = new Date(now);
    targetDate.setDate(now.getDate() + daysUntilSunday);
    targetDate.setHours(23, 59, 59, 999);
    
    return targetDate.getTime();
  }

  
  // Formatta numeri con zero iniziale se necessario
  formatNumber(num) {
    return num < 10 ? `0${num}` : num;
  }
  
  // Aggiorna il countdown
  updateCountdown() {
    const now = new Date().getTime();
    let distance = this.countDownDate - now;
    
    // Resetta il countdown se terminato
    if (distance < 0) {
      this.countDownDate = this.getNextSundayMidnight();
      distance = this.countDownDate - now;
    }
    
    // Calcola giorni, ore, minuti e secondi
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    // Aggiorna gli elementi HTML
    if (this.daysElement) this.daysElement.innerText = this.formatNumber(days);
    if (this.hoursElement) this.hoursElement.innerText = this.formatNumber(hours);
    if (this.minutesElement) this.minutesElement.innerText = this.formatNumber(minutes);
    if (this.secondsElement) this.secondsElement.innerText = this.formatNumber(seconds);
  }
  
  // Avvia il countdown
  startCountdown() {
    // Aggiorna immediatamente per evitare il ritardo iniziale
    this.updateCountdown();
    
    // Aggiorna ogni secondo
    setInterval(() => this.updateCountdown(), 1000);
  }
}

// Inizializza tutti i countdown timers quando il DOM è pronto
document.addEventListener('DOMContentLoaded', function() {
  // Cerca tutti gli elementi countdown-timer nella pagina
  const countdownElements = document.querySelectorAll('[id^="countdown-timer-"]');
  
  // Inizializza un timer per ciascun elemento trovato
  countdownElements.forEach(element => {
    new CountdownTimer(element.id);
  });
});